import { Button } from "../button";
import type { ReactNode } from "react";

export type FooterProperties = {
  children?: ReactNode;
  labels: { done: string };
  onDone?: (() => void) | undefined;
};
export const Footer = ({ children, labels, onDone }: FooterProperties) => (
  <div className="flex flex-row-reverse items-center justify-between border-t border-t-light-gray px-8 py-4">
    <Button className="justify-self-end" onPress={onDone}>
      {labels.done}
    </Button>
    {typeof children === "string" ? (
      <div className="text-legal">{children}</div>
    ) : (
      children
    )}
  </div>
);
Footer.displayName = "DatePicker.Footer";
